import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState, useRef, useEffect, useCallback, cloneElement, createElement, isValidElement } from 'react';
import { Element, ForwardRef, typeOf } from 'react-is';
import cn from 'classnames';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Manager, Reference, Popper } from 'react-popper';
import { LayeringConsumer } from '@rescui/ui-contexts';
import styles from './index.p.module.css.js';
import { useTooltipState, TOOLTIP_STATES } from './use-tooltip-state.js';
var HIDE_TIMEOUT = 500; // it should in sync with the transition-duration css-property

var CLOSING_TIMEOUT = 300;

var Portal = function Portal(_ref) {
  var children = _ref.children,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? document.body : _ref$target;
  return /*#__PURE__*/ReactDOM.createPortal(children, target);
};

var isNode = function isNode(maybeNode) {
  switch (_typeof(maybeNode)) {
    case 'string':
    case 'number':
      return true;

    case 'object':
      if ( /*#__PURE__*/isValidElement(maybeNode)) {
        return true;
      }

      if (Array.isArray(maybeNode)) {
        return maybeNode.every(isNode);
      }

      return false;

    default:
      return false;
  }
};

var Tooltip = function Tooltip(_ref2) {
  var children = _ref2.children,
      _ref2$targetComponent = _ref2.targetComponent,
      targetComponent = _ref2$targetComponent === void 0 ? 'span' : _ref2$targetComponent,
      content = _ref2.content,
      className = _ref2.className,
      isVisibleFromProps = _ref2.isVisible,
      modifiers = _ref2.modifiers,
      _ref2$placement = _ref2.placement,
      placement = _ref2$placement === void 0 ? 'auto' : _ref2$placement,
      _ref2$sparse = _ref2.sparse,
      sparse = _ref2$sparse === void 0 ? true : _ref2$sparse,
      disableHideDelay = _ref2.disableHideDelay;
  var isControlled = typeof isVisibleFromProps !== 'undefined';

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isVisibleState = _useState2[0],
      setIsVisibleState = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isTooltipHovered = _useState4[0],
      setIsTooltipHovered = _useState4[1];

  var schedulePopperUpdateRef = useRef(null);
  var hideTimeoutRef = useRef(null);
  var isVisible = isControlled ? isVisibleFromProps : isVisibleState;
  var isOpen = isVisible || isTooltipHovered;
  useEffect(function () {
    if (schedulePopperUpdateRef.current) {
      schedulePopperUpdateRef.current();
    }
  }, [content]);

  var handleMouseEnterTarget = function handleMouseEnterTarget() {
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = null;
    }

    setIsVisibleState(true);
  };

  var handleMouseLeaveTarget = function handleMouseLeaveTarget() {
    if (disableHideDelay) {
      setIsVisibleState(false);
    } else {
      hideTimeoutRef.current = setTimeout(function () {
        setIsVisibleState(false);
      }, HIDE_TIMEOUT);
    }
  };

  var tooltipState = useTooltipState(isOpen, CLOSING_TIMEOUT);
  var isClosing = tooltipState === TOOLTIP_STATES.CLOSING;
  var isExists = tooltipState !== TOOLTIP_STATES.CLOSED; // a state to toggle the starting transition

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isInitial = _useState6[0],
      setIsInitial = _useState6[1]; // reset the initial flag when the closing transition ends and the state switches to CLOSED


  useEffect(function () {
    if (!isExists) {
      setIsInitial(true);
    }
  }, [isExists]);
  var disableInitialFlag = useCallback(function (_ref3) {
    var state = _ref3.state;
    var el = state.elements.popper; // force layout phase
    // to make sure that the dom has registered the initial
    // styles with resolved placement (for `auto` placement)

    el.getBoundingClientRect();
    setIsInitial(false);
  }, []);
  return /*#__PURE__*/React.createElement(LayeringConsumer, null, function (_ref4) {
    var _context2;

    var tooltipZIndex = _ref4.tooltipZIndex;
    return /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, null, function (_ref5) {
      var _context;

      var ref = _ref5.ref;
      var eventListeners = !isControlled ? {
        onMouseEnter: handleMouseEnterTarget,
        onMouseLeave: handleMouseLeaveTarget,
        onFocus: handleMouseEnterTarget,
        onBlur: handleMouseLeaveTarget,
        tabIndex: 0
      } : {};

      var tooltipTargetProps = _Object$assign({}, {
        ref: ref
      }, eventListeners);

      if (typeof children === 'function') {
        return children({
          targetProps: tooltipTargetProps
        });
      } else if (_includesInstanceProperty(_context = [Element, ForwardRef]).call(_context, typeOf(children))) {
        return /*#__PURE__*/cloneElement(children, _objectSpread({
          className: cn(styles.trigger, children.props.className)
        }, tooltipTargetProps));
      } // create trigger-wrapper to bind tooltip


      return /*#__PURE__*/createElement(targetComponent, _objectSpread({
        className: styles.trigger
      }, tooltipTargetProps), children);
    }), isExists && isNode(content) && /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Popper, {
      placement: placement,
      modifiers: _concatInstanceProperty(_context2 = [// the modifier to trigger starting animation
      {
        name: 'disableInitialFlag',
        enabled: true,
        phase: 'afterWrite',
        fn: disableInitialFlag,
        requires: []
      }, {
        name: 'offset',
        options: {
          offset: function offset(_ref6) {
            var offsetPlacement = _ref6.placement;

            if (_includesInstanceProperty(offsetPlacement).call(offsetPlacement, 'left') || _includesInstanceProperty(offsetPlacement).call(offsetPlacement, 'right')) {
              return [0, sparse ? 16 : 8];
            } else {
              return [0, sparse ? 12 : 8];
            }
          }
        }
      }]).call(_context2, _toConsumableArray(modifiers || []))
    }, function (_ref7) {
      var ref = _ref7.ref,
          style = _ref7.style,
          update = _ref7.update,
          realPlacement = _ref7.placement;
      schedulePopperUpdateRef.current = update;
      return /*#__PURE__*/React.createElement("span", {
        className: cn(styles.tooltip, isInitial && styles.initial, isClosing && styles.closing, className),
        ref: ref,
        style: _objectSpread(_objectSpread({}, style), {}, {
          zIndex: tooltipZIndex
        }),
        onMouseEnter: function onMouseEnter() {
          return setIsTooltipHovered(true);
        },
        onMouseLeave: function onMouseLeave() {
          setIsVisibleState(false);
          setIsTooltipHovered(false);
        },
        "data-placement": placement,
        "data-real-placement": realPlacement,
        "data-test": "tooltip"
      }, /*#__PURE__*/React.createElement("div", {
        className: cn(styles.content)
      }, content));
    })));
  });
};

Tooltip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  targetComponent: PropTypes.string,
  content: PropTypes.node,
  className: PropTypes.string,
  isVisible: PropTypes.bool,
  modifiers: PropTypes.array,
  placement: PropTypes.oneOf(['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start']),
  sparse: PropTypes.bool,
  disableHideDelay: PropTypes.bool
};
export { Tooltip, Tooltip as default };
